// global.$ = global.jQuery = require('jquery');
import { createApp } from 'vue'
import mitt from 'mitt'
import DashboardView from '@vueapp/views/Dashboard.vue'

import VueTippy from 'vue-tippy'

export class Dashboard {

	constructor( elements ) {
        
        let _this = this

        if ( elements.length ) {
            elements.forEach(function (item, key) {
            	const emitter = mitt()
				const app = createApp(DashboardView, {
					postId: item.getAttribute('data-post-id'),
					postSlug: item.getAttribute('data-post-slug')
				})
				app.config.globalProperties.emitter = emitter
				app.mount('#' + item.getAttribute('id') )    

				app.use(
				  VueTippy,
				  // optional
				  {
				    directive: 'tippy', // => v-tippy
				    component: 'tippy', // => <tippy/>
				    componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,

				    defaultProps: {
				      	// placement: 'auto-end',
				      	allowHTML: true,
				      	theme: 'bryter',
			    	    placement: 'right',
				    }, // => Global default options * see all props
				  }
				)
            })
        }
		

	}
	

}